var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 284,
    viewBox: "0 0 246 284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.753 136.358C202.189 136.627 199.314 137.552 197.987 138.215C197.621 138.397 197.294 138.519 197.261 138.485C197.227 138.451 191.351 141.714 184.204 145.737L171.209 153.051L171.137 169.274L171.065 185.497L164.06 189.438L157.056 193.379V201.631C157.056 206.169 157.081 209.883 157.112 209.883C157.143 209.883 160.225 208.162 163.96 206.059C167.695 203.956 170.838 202.202 170.944 202.161C171.104 202.1 171.137 203.753 171.137 211.881C171.137 217.267 171.176 221.674 171.224 221.674C171.271 221.674 174.44 219.913 178.264 217.761L185.218 213.848V203.971V194.094L188.989 191.973C197.809 187.014 199.531 185.801 203.762 181.565C208.709 176.61 212.14 171.045 214.361 164.371C216.541 157.819 217.102 150.903 215.896 145.444C214.871 140.802 212.59 137.934 208.926 136.68C208.17 136.421 207.621 136.354 206.052 136.328C204.985 136.31 203.95 136.324 203.753 136.358ZM200.239 156.889C202.669 158.315 202.204 164.252 199.368 168.005C197.992 169.825 195.715 171.766 193.853 172.706C193.195 173.038 187.776 176.065 185.828 177.188L185.218 177.54V170.211V162.881L187.193 161.77C188.28 161.159 190.301 160.012 191.683 159.22C194.892 157.384 195.402 157.13 196.712 156.723C198.09 156.294 199.323 156.352 200.239 156.889Z",
    fill: "#4A67FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125 127L32 71.5L125 16.5V127Z",
    fill: "#0F2490"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.976 123.848L213 71L122.976 19.5V123.848Z",
    fill: "#233BB9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.98 0L0.00390625 71L0 213L122.976 284L122.98 143.42L245.955 71L122.98 0ZM33.8315 71.1457L122.98 19.6761L212.128 71.1457L122.98 123.645L33.8315 71.1457Z",
    fill: "#4A67FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.46ea7c99c1bc6062528d6246ba679aad.svg";
export { ForwardRef as ReactComponent };